export default "__VITE_ASSET__3a10e16f__"